import type { FC } from 'react';
import { createPortal } from 'react-dom';
import Button from '@components/Button';
import { POPOVER_Z_INDEX } from '@constants/z-indices';
import { cn } from 'cn';
import { MessageSquarePlus } from 'lucide-react';

interface InlineCommentPillProps {
  rect: { left: number; bottom: number; width: number };
  onClick: () => void;
}

export const InlineCommentPill: FC<InlineCommentPillProps> = ({ rect, onClick }) =>
  createPortal(
    <div
      className={cn('fixed -translate-x-1/2', POPOVER_Z_INDEX)}
      // mousedown elsewhere collapses the selection before the click lands; keep it alive for the pill.
      onMouseDown={(event) => event.preventDefault()}
      style={{ top: rect.bottom + 8, left: rect.left + rect.width / 2 }}
    >
      <Button
        className="h-[30px] gap-1 rounded-full px-2 py-1.5 text-xs shadow-lg"
        data-testid="inline-add-comment-button"
        kind="primary"
        onClick={onClick}
        size="sm"
      >
        <MessageSquarePlus className="size-[18px]" />
        Add a comment
      </Button>
    </div>,
    document.body,
  );
